export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "items",
      layout: "dashboard",
    },
    path: "/items",
    name: "items",
    component: () => import("@/layouts/index/ItemsIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste d'articles",
          layout: "dashboard",
        },
        path: "index",
        name: "items-index",
        component: () => import("@/views/Items/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un produit",
          layout: "dashboard",
        },
        path: "create",
        name: "items-create",
        component: () => import("@/views/Items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "items-edit",
        component: () => import("@/views/Items/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "items-details",
        component: () => import("@/views/Items/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Prix ​​d'articles",
          layout: "dashboard",
        },
        path: "prices/index",
        name: "items-prices-index",
        component: () => import("@/views/item_prices/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Attribuer les prix de cet élément",
          layout: "dashboard",
        },
        path: "prices/create",
        name: "items-prices-create",
        component: () => import("@/views/item_prices/Create.vue"),
      },
    ],
  },
];
